import React from "react";
import "./HeroSection.css";
import bgImage from "../assets/background.png";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <div
      className="hero-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="hero-overlay">

        <div className="hero-content">
          <h1>Get the best-in-class products with us.</h1>

          <p>
            We specialize in delivering end-to-end solutions—from design
            collaboration to production
          </p>

          <Link to="/contactus" className="hero-btn">
            Contact Us
          </Link>
        </div>

        <div className="circle"></div>

      </div>
    </div>
  );
};

export default HeroSection;